import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Package, MapPin, PenTool, Settings, Plus, Home, Users, Zap, GraduationCap, Layers, DollarSign, Briefcase, Image } from 'lucide-react';

interface QuickAction {
  icon: React.ReactNode;
  title: string;
  link: string;
}

interface QuickActionsProps {
  title?: string;
}

const QuickActions: React.FC<QuickActionsProps> = ({ title = "Actions Rapides" }) => {
  const actions: QuickAction[] = [
    {
      icon: <FileText size={18} className="text-primary-500" />,
      title: "Créer un article",
      link: "/admin/blog/new"
    },
    {
      icon: <Package size={18} className="text-primary-500" />,
      title: "Ajouter un produit",
      link: "/admin/products/new"
    },
    {
      icon: <MapPin size={18} className="text-primary-500" />,
      title: "Ajouter une station",
      link: "/admin/locations/new"
    },
    {
      icon: <Home size={18} className="text-primary-500" />,
      title: "Éditer la page d'accueil",
      link: "/admin/content/home"
    },
    {
      icon: <Users size={18} className="text-primary-500" />,
      title: "Éditer À Propos",
      link: "/admin/content/about"
    },
    {
      icon: <Zap size={18} className="text-primary-500" />,
      title: "Éditer Services",
      link: "/admin/content/services"
    },
    {
      icon: <GraduationCap size={18} className="text-primary-500" />,
      title: "Éditer Formation",
      link: "/admin/content/training"
    },
    {
      icon: <Layers size={18} className="text-primary-500" />,
      title: "Éditer Proxy Power",
      link: "/admin/content/proxy-power"
    },
    {
      icon: <DollarSign size={18} className="text-primary-500" />,
      title: "Éditer Investir",
      link: "/admin/content/invest"
    },
    {
      icon: <Briefcase size={18} className="text-primary-500" />,
      title: "Éditer Carrières",
      link: "/admin/content/careers"
    },
    {
      icon: <Image size={18} className="text-primary-500" />,
      title: "Gérer les médias",
      link: "/admin/content/media"
    },
    {
      icon: <Settings size={18} className="text-primary-500" />,
      title: "Paramètres du site",
      link: "/admin/settings"
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions.map((action, index) => (
          <Link 
            key={index}
            to={action.link}
            className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {action.icon}
            <span className="text-sm font-medium text-gray-700">{action.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;